/* eslint-disable eqeqeq */
/*
 * Author M. Atoar Rahman
 * Title: D4 Report DataTable
 * Description: D4 Report DataTable
 * Date: 15/03/2022
 */

import { Fragment } from 'react';
import useDataTable from '../../../hooks/useDataTable';

export default function DataTable({ medicinData, partner, dateOrMonthRange }) {
    const tableStyle = {
        paddingLeft: '5px',
        paddingRight: '5px',
        lineHeight: '33px',
    };

    function ItemTitle() {
        return <span className="ps-2">Item Name</span>;
    }

    const partnerLength = partner?.length;

    function Title() {
        return (
            <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                <thead>
                    <tr>
                        <th colSpan={2 + partnerLength} className="m-0">
                            {dateOrMonthRange}
                        </th>
                    </tr>
                    <tr>
                        <th
                            style={{ minWidth: '110px', maxWidth: '110px' }}
                            className="m-0"
                        >
                            Opening Balance
                        </th>
                        {partner?.map((el) => (
                            <th
                                style={{ minWidth: '110px', maxWidth: '110px' }}
                                key={Math.random() * 1000}
                                className="m-0"
                            >
                                {el.name}
                            </th>
                        ))}
                        <th style={{ minWidth: '110px', maxWidth: '110px' }} className="m-0">
                            Total
                        </th>
                    </tr>
                    <tr>
                        <th className="m-0" />
                        {partner?.map((el) => (
                            <th key={el.id} className="m-0">
                                Total Dispatch
                            </th>
                        ))}
                        <th className="m-0">Total Dispatch</th>
                    </tr>
                </thead>
            </table>
        );
    }

    const columns = [
        {
            name: <ItemTitle />,
            cell: (row) => <span className="ps-2">{row.drug_name}</span>,
            sortable: true,
            wrap: true,
            width: '250px',
            fixed: true,
        },
        {
            name: <Title />,
            cell: (row) => (
                <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                    <tbody>
                        <tr style={{ borderTopWidth: '0px' }}>
                            <td style={{ minWidth: '110px', maxWidth: '110px' }}>
                                {row.opening_balance || 0}
                            </td>
                            {partner?.map((ele) => {
                                const item = row?.partner_summary_data?.find(
                                    (s) =>
                                        s &&
                                        parseInt(s.partner_id, 10) ===
                                            parseInt(ele.id, 10),
                                );
                                return (
                                    <Fragment key={ele.id}>
                                        <td
                                            style={{
                                                minWidth: '110px',
                                                maxWidth: '110px',
                                            }}
                                        >
                                            {item?.total_dispatch || 0}
                                        </td>
                                    </Fragment>
                                );
                            })}
                            <td style={{ minWidth: '110px', maxWidth: '110px' }}>
                                {row.overall_dispatch || 0}
                            </td>
                        </tr>
                    </tbody>
                </table>
            ),
        },
    ];

    const search_column = { name: 'Name' };
    return useDataTable({
        columns,
        data: medicinData,
        search_column,
        pagination: false,
        cellPadding: '0px',
        borderWidth: '0px',
    });
}